export default __webpack_public_path__ + "static/media/logo_cymsa.0d425bdf.jpg";